<template>
  <div
    v-loading="isLoading"
    class="materiral-file"
  >
    <div class="top-search">
      <div class="search-input">
        <mk-input
          v-model="name"
          :disabled="isBatch"
          suffix-icon="el-icon-search"
          width="240"
          placeholder="输入文件名称"
          class="mr-r-10"
        ></mk-input>
        <mk-select
          v-model="fileType"
          :disabled="isBatch"
          width="200"
          placeholder="文件类型"
          clearable
          filterable
        >
          <mk-option
            v-for="item in fileTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-button-biz
          class="reset"
          icon="el-icon-search"
          size="small"
          type="primary"
          @click="handleOnSearch"
        >
          搜索
        </mk-button-biz>
        <mk-button-biz
          class="reset"
          size="small"
          @click="reset"
        >
          重置
        </mk-button-biz>
      </div>
      <div class="top-search-right">
        <!-- <mk-button-biz
          :disabled="isBatch || data.length === 0"
          class="batch cursor"
          @click="openBatchOp"
        >
          批 量
        </mk-button-biz> -->
        <mk-popover
          placement="left"
          trigger="hover"
          :visible-arrow="false"
          popper-class="courseware-manage-popover"
        >
          <div class="mention-text">
            <ds-iconfont icon-class="icon-ds-tishi" />文件大小不超过20M
          </div>
          <mk-button-biz
            slot="reference"
            :disabled="isBatch"
            class="upload-button"
            height="32px"
            width="104px"
            type="primary"
            size="small"
            @click="uploadClick"
          >
            <ds-iconfont
              icon-class="icon-mk-upload"
            />
            上传文件
          </mk-button-biz>
        </mk-popover>
      </div>
    </div>
    <div
      ref="table"
      class="file-list"
    >
      <mk-table
        v-if="tableMaxHeight"
        ref="tableList"
        :max-height="tableMaxHeight"
        :data="data"
        style="width: 100%;"
        @select="fileSelectItem"
        @select-all="fileHandleOnCheckedChange"
      >
        <mk-table-column
          v-if="isBatch"
          type="selection"
          width="45"
        >
        </mk-table-column>
        <mk-table-column
          prop="date"
          label="文件名称"
          min-width="330"
          fixed="left"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <!-- <mk-tooltip
              effect="dark"
              content="点击编辑名称"
              placement="top"
              popper-class="courseware-manage-tooltip"
            >
              <span
                v-show="!scope.row.inputVisible"
                class="file-name"
              >{{ scope.row.name + '.' + scope.row.suffix }}</span>
            </mk-tooltip> -->
            <span
              v-show="!scope.row.inputVisible"
              class="file-name"
            >{{ scope.row.name + '.' + scope.row.suffix }}</span>
            <div
              v-show="scope.row.inputVisible"
              class="input-wrapper"
            >
              <mk-input
                :ref="'changeNameInput' + scope.row.id"
                v-model="inputVal"
                maxlength="20"
                show-word-limit
                @blur="changeName(scope.row)"
              ></mk-input>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          min-width="120"
          label="类型"
        >
          <template v-slot="scope">
            <span v-if="scope.row.fileType === 1">文档</span>
            <span v-else-if="scope.row.fileType === 2">表格</span>
            <span v-else-if="scope.row.fileType === 3">PDF</span>
            <span v-else-if="scope.row.fileType === 4">TXT</span>
            <span v-else-if="scope.row.fileType === 5">幻灯片</span>
            <span v-else-if="scope.row.fileType === 6">图片</span>
            <span v-else-if="scope.row.fileType === 7">音频</span>
            <span v-else>视频</span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="大小"
          min-width="120"
        >
          <template v-slot="scope">
            {{ filter(scope.row.size) }}
          </template>
        </mk-table-column>
        <mk-table-column
          prop="createTime"
          label="上传日期"
          width="160"
        >
        </mk-table-column>
        <mk-table-column
          label="操作"
          width="180"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              class="operate"
              :disabled="isBatch"
              @click="downloadFile(scope.row)"
            >
              下载
            </mk-button-biz>
            <mk-popover
              :ref="`popover-${scope.$index}`"
              placement="top"
              trigger="click"
              popper-class="courseware-manage-delete-confirm"
            >
              <div>
                <div class="mention-text">
                  <ds-iconfont icon-class="icon-ds-tishi" />你确定删除这项素材吗？
                </div>
                <div class="button">
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    @click="ordinaryDelete(scope.row._id),$refs[`popover-${scope.$index}`].$children[0].doClose()"
                  >
                    删除
                  </mk-button-biz>
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    type="primary"
                    @click="$refs[`popover-${scope.$index}`].$children[0].doClose()"
                  >
                    取消
                  </mk-button-biz>
                </div>
              </div>
              <mk-button-biz
                slot="reference"
                :disabled="isBatch"
                type="text"
                class="operate"
              >
                删除
              </mk-button-biz>
            </mk-popover>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div
      v-if="!isBatch"
      class="pagination"
    >
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
    <!-- 全选操作 -->
    <footer-toolbar
      v-if="isBatch"
      class="tag-batch-op-toolbar"
      :select-all="selectAll"
      :selection="currentSelection"
      @on-checked-change="handleOnCheckedChange"
      @on-remove-click="handleOnToolbarRemoveClick"
      @on-apply-click="handleOnToolbarApplyClick"
      @on-cancel-click="handleOnToolbarCloseClick"
    />
    <!-- 是否批量删除 -->
    <mk-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>是否删除选中文件</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleOnToolbarRemoveClickCenter"
        >确 定</el-button>
      </span>
    </mk-dialog>
    <muti-upload
      ref="upload"
      :accept="accept"
      :limit-size="20"
      type="mba"
      :category="type"
      @finish="onUploadFinish"
    ></muti-upload>
  </div>
</template>

<script>
import CommonData from '../common'
import MutiUpload from '../muti-upload'
export default {
  name: 'MaterialImage',
  components: {
    MutiUpload
  },
  mixins: [CommonData],
  data () {
    return {
      tableMaxHeight: 0,
      type: 3,
      // 上传接受的文件类型
      accept: '.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.mp3,.m4a',
      fileTypeOptions: [
        { label: '文档', value: 1 },
        { label: '表格', value: 2 },
        { label: 'PDF', value: 3 },
        { label: '幻灯片 ', value: 5 },
        { label: '音频', value: 7 }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.file-list', this)
    })
  },
  methods: {

    showInput (data) {
      let { name, _id } = data
      this.inputVal = name
      this.currentVal = name
      this.currentId = _id
      this.data.forEach((item, index) => {
        item.inputVisible = false
      })
      data.inputVisible = true
      this.$nextTick(() => {
        let refsName = 'changeNameInput' + data.id
        this.$refs[refsName].$children[0].focus()
      })
    },
    // 修改资料名
    async changeName (data) {
      if (!this.inputVal) {
        return this.$message.error('保存失败，名称不能为空')
      }
      if (this.currentVal === this.inputVal) {
        data.inputVisible = false
        return
      }
      let params = {
        _id: this.currentId,
        name: this.inputVal,
        directory: data.directory,
        suffix: data.suffix
      }
      let res = await MKMATERIALSVC.MbamaterialApi.mbamaterialUpdatePost(params)
      if (res.success) {
        this.$message.success('保存成功')
        this.mbamaterialListPost()
      } else {
        this.$message.error('保存失败')
      }
      data.inputVisible = false
    },

    // 换算单位
    filter (size) {
      let tarSize = size / 1024 > 1024 ? Math.round(size / 1024 / 1024 * 10) / 10 + 'M' : Math.round(size / 1024) + 'KB'
      return tarSize
    },
    // 重置
    reset () {
      this.name = ''
      this.fileType = ''
      this.onInput()
    }
  }
}
</script>

<style lang="scss" scoped>
.materiral-file {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .top-search {
    padding: 10px 20px 0;
    position: relative;

    /deep/ .tag-select {
      display: inline-block;
      margin-right: 10px;
    }

    .mr-r-10 {
      margin-right: 10px;
    }

    .top-search-right {
      position: absolute;
      right: 20px;
      top: 10px;

      .batch {
        border: 1px solid #ccecff;
        color: #1b9aee;
        font-size: 14px;
        line-height: 20px;
        margin-right: 10px;
        padding: 7px 14px;
        border-radius: 4px;
      }

      /deep/ .is-disabled {
        color: #d9d9d9;
        border: 1px solid #d9d9d9;
      }

      .upload-button {
        .icon-mk-upload {
          color: #fff;
          font-size: 13px;
        }
      }
    }
  }

  .file-list {
    height: 100%;
    padding: 0 20px;
    margin: 10px 0 0;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    flex: 1;

    // .file-name {
    //   cursor: pointer;

    //   &:hover {
    //     color: #009cff;
    //   }
    // }

    .input-wrapper {
      padding: 1px 0;
    }

    .operate {
      font-size: 13px;
      font-weight: 400;
      color: #009cff;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .material-list {
    height: 100%;
    overflow-y: auto;
    margin-top: 20px;
    padding-left: 30px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 20px;
    // border-top: 1px solid #e8e8e8;

    .total {
      color: #6d7278;
      font-size: 13px;
    }

    .mk-pagination {
      margin-top: 0;
    }
  }

  .tag-select-cascader {
    margin-right: 10px;
  }

  .reset {
    margin-left: 10px;
  }
}
</style>
